import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-m-5" }
const _hoisted_2 = {
  for: "advanced-options",
  class: "kn-material-input-label"
}
const _hoisted_3 = {
  key: 0,
  class: "p-fluid p-m-2"
}
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "modelName",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "schemaName",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "catalogName",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-d-flex p-mt-4" }
const _hoisted_14 = { class: "p-field-checkbox p-mr-3" }
const _hoisted_15 = { class: "p-field-checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.generateDatamartCardDescriptor.dialog.style,
    visible: true,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    header: _ctx.$t('managers.businessModelManager.generateDatamart'),
    closable: false,
    "aria-label": "Generate Datamart Options"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeTemplate
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        onClick: _ctx.generateDatamart
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("p", null, _toDisplayString(_ctx.$t('managers.businessModelManager.generateDatamartHint')), 1),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_InputSwitch, {
          id: "advanced-options",
          class: "p-mr-2",
          modelValue: _ctx.showAdvancedOptions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAdvancedOptions = $event))
        }, null, 8, ["modelValue"]),
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('managers.businessModelManager.showAdvancedOptions')), 1)
      ]),
      (_ctx.showAdvancedOptions)
        ? (_openBlock(), _createBlock("form", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_InputText, {
                  id: "modelName",
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.modelName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelName = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.businessModelManager.modelName')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_InputText, {
                  id: "schemaName",
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.schemaName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.schemaName = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.businessModelManager.schemaName')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_InputText, {
                  id: "catalogName",
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.catalogName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.catalogName = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.businessModelManager.catalogName')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("span", _hoisted_14, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.isGeneratedForRegistry,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isGeneratedForRegistry = $event)),
                  binary: true,
                  "aria-label": "Generate for Registry"
                }, null, 8, ["modelValue"]),
                _createVNode("label", null, _toDisplayString(_ctx.$t('managers.businessModelManager.forRegistry')), 1)
              ]),
              _createVNode("span", _hoisted_15, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.includeSources,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.includeSources = $event)),
                  binary: true,
                  "aria-label": "Include Sources"
                }, null, 8, ["modelValue"]),
                _createVNode("label", null, _toDisplayString(_ctx.$t('managers.businessModelManager.includeSources')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "header"]))
}